import React, { useState, useEffect } from "react";
import { Dialog, Tooltip } from "@mui/material";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { endpoint } from "views/pages/manage/common/constant";
import EnhanceDataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { LastUpdatedDetails } from "views/pages/manage/employeeManagement/userProfile/helper";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { capitalize } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const ViewResultLogs = ({ viewLogs, closeLogs }) => {
  const [isFetching, setIsFetching] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async (page = currentPage, limit = pageSize) => {
    const response = await fetchAllPromisedData(
      `${endpoint.studentResult.viewEditResultLogs}/${viewLogs.id}?offset=${page}&limit=${limit}`
    );

    setIsFetching(false);

    setRowData(response?.testPlayerResultAuditList || []);
    setTotalRows(response?.totalRecords || 0);
  };

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    setCurrentPage(pageNum);
    setPageSize(updatedPageSize);

    fetchLogs(pageNum, updatedPageSize);
  };

  const columns = [
    new AGridColDef("event", "Field").renderCellComponent((params) =>
      params?.value ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">
            {capitalize(params?.value)}
          </div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("oldValue", "Old Value").renderCellComponent((params) =>
      params?.value?.trim() ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">{params?.value}</div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("newValue", "Updated Value").renderCellComponent((params) =>
      params?.value ? (
        <Tooltip title={params?.value}>
          <div className="ellipsis-text-container">{params?.value}</div>
        </Tooltip>
      ) : (
        <div className="m-auto">-</div>
      )
    ),
    new AGridColDef("updatedOn", "Updated On")
      .setFlex(1.3)
      .renderCellComponent((params) => (
        <div className="m-auto">{LastUpdatedDetails(params.value)}</div>
      )),

    new AGridColDef("updatedBy", "Updated By").renderCellComponent((params) => (
      <div className="m-auto">{params.value}</div>
    )),
  ];

  return (
    <Dialog
      aria-label="Edit History"
      open={viewLogs.isOpen}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          height: "380px",
          minWidth: "800px",
          padding: "20px",
        },
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-bold">Activity Logs</h3>

        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={closeLogs}
          disabled={isFetching}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <EnhanceDataGrid
        removeWrapperContainer
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={isFetching}
        rowCount={totalRows}
        nextButtonHandler={nextButtonHandler}
        currentPage={currentPage}
        paginationModel={{
          page: currentPage,
          pageSize: pageSize,
        }}
      />
    </Dialog>
  );
};

export default ViewResultLogs;
